import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import Icon from './Icon';

export default class BlankSlate extends React.Component {
    getHelpLink() {
        return <span dangerouslySetInnerHTML={{ __html: this.props.helpLink }} />;
    }

    render() {
        var classes = getComponentClasses('blank-slate', this.props.variations);

        return (
            <div className={classes}>
                <div className="blank-slate__icon">
                    <Icon variations={[this.props.icon]} />
                </div>
                <h2 className="blank-slate__heading">{this.props.message}</h2>
                {this.props.helpLink && this.getHelpLink()}
            </div>
        );
    }
}

BlankSlate.propTypes = {
    message: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    helpLink: PropTypes.string,
    variations: PropTypes.array,
};

BlankSlate.defaultProps = {
    helpLink: null,
    variations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/BlankSlate.jsx